export default "__VITE_ASSET__707db9c4__"